/* src/app/forms/wizard-configuracao/main-configuracao-grid/main-configuracao-grid.component.scss */
:host {
  display: flex;
  height: 100%;
  flex-direction: column;
  overflow: auto;
}
.view-component {
  border: 1px solid rgba(0, 0, 0, 0.03);
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.24), 0 0 2px rgba(0, 0, 0, 0.12);
  margin: 0px;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
}
.title {
  width: 100%;
  padding: 6px;
  text-align: right;
  font-size: 100%;
}
.maindiv {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: auto;
}
/*# sourceMappingURL=main-configuracao-grid.component.css.map */
